import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import oktaAuth from 'services/okta';
import { loginWithOkta } from 'slices/userSlice';

function OktaCallback() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorDetail, setErrorDetail] = useState(null);

    useEffect(() => {
        const handleCallback = async () => {
            try {
                await oktaAuth.handleLoginRedirect();
                const idToken = oktaAuth.getIdToken();

                if (!idToken) {
                    throw new Error('No ID token received from Okta. The token manager may be empty.');
                }

                dispatch(loginWithOkta(idToken, (success) => {
                    if (success) {
                        toast.success('Login Successfully', { className: 'successToast' });
                        navigate('/', { replace: true });
                    } else {
                        setErrorDetail('Account not found or server error. Please contact support.');
                    }
                }));
            } catch (err) {
                console.error('[Okta SSO] Callback error:', err);
                setErrorDetail(err.message || 'Unknown error during SSO login.');
            }
        };

        handleCallback();
    }, []);

    if (errorDetail) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(to bottom, #7b8cde, #56ccf2)' }}>
                <div style={{ textAlign: 'center', color: '#fff', maxWidth: '420px', padding: '2rem' }}>
                    <p style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>SSO Login Failed</p>
                    <p style={{ fontSize: '0.95rem', opacity: 0.85, marginBottom: '1.5rem' }}>{errorDetail}</p>
                    <button
                        onClick={() => navigate('/login', { replace: true })}
                        style={{ background: '#fff', color: '#1a1a2e', border: 'none', borderRadius: '999px', padding: '0.6rem 2rem', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        Back to Login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(to bottom, #7b8cde, #56ccf2)' }}>
            <div style={{ textAlign: 'center', color: '#fff' }}>
                <Spinner style={{ width: '3rem', height: '3rem' }} />
                <p style={{ marginTop: '1rem', fontSize: '1.1rem' }}>Completing login...</p>
            </div>
        </div>
    );
}

export default OktaCallback;
